/**
 * 路由守卫
 *  */
 import router from './router';
 import VueRouter from "vue-router";
import store from './store';
import { getStore } from "@/utils/localStorage";
import { Message, MessageBox } from 'element-ui';
import {constantRoutes, asyncRoutes} from './router.js';

import {getVersion} from "@/api/common";

// 判断浏览器 谷歌浏览器/safari浏览器
let browserHandle = () => {
    let userAgent = navigator.userAgent; //取得浏览器的userAgent
    let isChrome =  userAgent.indexOf('Chrome') > -1;  // 是否是谷歌浏览器
    // /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)
    let isSafari = userAgent.indexOf('Safari') > -1 && !isChrome;  // 是否是safari浏览器
    return isChrome || isSafari;
}

// 判断当前版本 这里版本号写死
let editionHanle = async () => {
    let versionNo = '5.0.50'; //正式最新服版本号 2.4.20
    let data = {
        tag: 'stu_pc_version',  //stu_pc_version 学生PC端，stu_wap_version 学生移动端，boss_version 管理端
    };
    let res = await getVersion(data);
    return res.result === versionNo;
}

// 判断登录信息
const loginInfoHandle = (to, from, next) => {
    let userInfo = JSON.parse(store.state.permission.userInfo);
    let _ENTRANCETYPE = store.state.permission._ENTRANCETYPE;
    let enterConfirm =  store.state.permission.enterConfirm;
    let firstLoginVerify = store.state.permission.firstLoginVerify;
    let classId = userInfo.classList[0].class_id;
    let enterSchoolImgCheck = store.state.permission.enterSchoolImgCheck;
    if(_ENTRANCETYPE === 'adult'){
        if(enterConfirm == 0){
            if(to.name !== 'confirmInfo'){
                next({name: "confirmInfo", replace: true});
                // router.push({path: "/confirmInfo"});
                return false;
            }else{
                next();
            }
        }else if(firstLoginVerify == 0){
            let verifyPageList = ['changePwd'];
            if(to.name !== 'verify'){
                if(verifyPageList.includes(to.name)){
                    next();
                }else{
                    next({name: "verify",query: {classId}, replace: true});
                    // router.push({path: "/verify",query: {classId}});
                }
                return false;
            }else{
                next();
            }
        }else if(enterSchoolImgCheck != 2){
            if(to.name !== 'uploadAdmissionPhotos'){
                next({name: "uploadAdmissionPhotos", replace: true});
                // router.push({path: "/uploadAdmissionPhotos"});
                return false;
            }else{
                next();
            }
        }
    }
    // next({name: 'home'});
    return true;
}

 router.beforeEach(async (to, from, next) => {

    // if(!store.state.common.s3Client){
    //     store.dispatch("common/getS3ClientAction"); // 获取腾讯云签名
    // }

    if (to.name === "uploadImg" || to.name === "upDataID" || to.name === "esignH5") {
        next();
        return;
    }

    // 检查版本号
    const isInspectVersion = store.state.permission.isInspectVersion;
    if(!isInspectVersion){
        let isVersion = await editionHanle();
        if(!isVersion){
            MessageBox.alert('当前版本未更新，请使用Ctrl + F5刷新页面', '', {
                showClose: false,
                showCancelButton: false,
                showConfirmButton: false,
                closeOnPressEscape: false,
                center: true,
            });
            return;
        }else{
            store.commit('permission/SET_isInspectVersion', true);
        }
    }

    let isChrome = browserHandle();
    if(!isChrome){
        MessageBox.alert('请使用谷歌浏览器', '', {
            confirmButtonText: '去下载',
            callback: res => {
                open('http://file.cdn.cqttech.com/file/ChromeCore_1189_5.1.8.10.exe', '_blank');
            }
        });
        return;
    }

    //不需要登录就能进入的路由
    const noToken = ["forgetPwd", "verifyCode", "appRule", "appPrivacy", "appDownload", "appHome", 'degreeApplication', 'graduationProve', 'graduationProveTable', 'academicDegreeRecord'];
    if (noToken.indexOf(to.name) != -1) {
        next();
    } else{
        const token = getStore("token");
        if(token){
            let enterSchoolImgCheck = store.state.permission._ENTRANCETYPE;;
            if(enterSchoolImgCheck === 'practicalAssessment'){
                // if(to.path === '/'){
                //     next({name: 'home'});
                // }else{
                //     next();
                // }
                next();
            }else{
                // 判断登录信息是否完善
                let isLoginInfo =  loginInfoHandle(to, from, next);
                if(isLoginInfo){
                    const isGenerateRoutes = store.state.permission.isGenerateRoutes;
                    if(!isGenerateRoutes){
                        if(to.path === '/'){
                            next({name: 'home'});
                        }else{
                            next();
                        }
                    }else{
                        try{
                            // 路由重写
                            store.dispatch('permission/generateRoutes').then((res) => {
                                // console.log(res);
                                router.matcher = new VueRouter().matcher; // 重置路由
                                router.options.routes = res;
                                router.addRoutes(res);
                                // store.dispatch('permission/setIsGenerateRoutes', false)   //路由已经从写 不需要再次重写
                                next({ ...to, replace: true });
                            })
                        }catch(error){
                            // console.log(error);
                            Promise.reject(error);
                            // 跳转登录页
                            next({name: "Login", replace: true});
                        }
                    }
                }
            }
        }else{
            if (to.name !== "Login") {
                // Message.error('未登录，请先登录');
                next({ name: "Login", replace: true});
            }else{
                next();
            }
        }
    }


 });
